import React, { Fragment, useState } from "react";
import { object } from "prop-types";
import FeatherIcon from "feather-icons-react";
import * as style from "../styles.module.scss";
import {
  isLegalComplianceCompleted,
  isRegistrationCompleted,
  navigateToStepOne,
  navigateToFirstNonCompletedStep,
} from "../../../helpers/profileRegistrationCard";

const TOTAL_REQUIRED = 2;

const ProfileCard = ({
  title,
  appData,
  description,
  onClick,
  btnText,
  iconName,
  iconClass,
  completed,
  total,
}) => {
  return (
    <Fragment>
      <div className={style.profileBoxWrapper}>
        <div className={style.imageCircle}>
          {appData.profileImage &&
          (appData.profileImage.previewContent || appData.profileImage.url) ? (
            <img
              alt="Circle Image"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              src={
                appData.profileImage.previewContent
                  ? `data:image/jpg;base64,${appData.profileImage.previewContent}`
                  : appData.profileImage.url
              }
            />
          ) : (
            <div
              style={{
                backgroundColor: "white",
                color: "gray",
                lineHeight: "92px",
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              {appData.firstName[0] + appData.lastName[0]}
            </div>
          )}
        </div>
        <div style={{ width: "100%" }}>
          <div
            style={{ width: "100%" }}
            className={`${style.profile__candidate_container} d-flex flex-column`}
          >
            <div className={`${style.profile__candidate_title}`}>
              {title}
              <b>
                {appData.firstName} {appData.lastName}
              </b>
            </div>
            <div>{description}</div>
            <div
              className={`${style.profile__candidate_icon} d-flex align-items-center`}
            >
              <FeatherIcon
                style={{ marginRight: "12px" }}
                icon={iconName}
                className={iconClass}
              />{" "}
              <span>
                {completed}/{total} sections completed
              </span>
            </div>
          </div>
          <div>
            <button
              className={`btn btn-outline-info text-dark ${style.profile__job_button}`}
              onClick={onClick}
            >
              {btnText}
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const CandidateProfileSection = ({ appData }) => {
  const section1Completed = isRegistrationCompleted(appData) ? 1 : 0;
  const section2Completed = isLegalComplianceCompleted(appData) ? 1 : 0;

  const totalCompleted = section1Completed + section2Completed;

  const sectionCompleted = totalCompleted === TOTAL_REQUIRED;

  return (
    <div
      style={{ width: "100%" }}
      className={`${style.profile__candidate} bg-white rounded d-flex flex-column text-left`}
      id="candidatePofileSection"
    >
      {sectionCompleted ? (
        <ProfileCard
          title={"Hi there, "}
          appData={appData}
          description={
            "The more info you add, the better the chance we can match you to the right job!"
          }
          iconName={"check-circle"}
          iconClass={"text-success"}
          btnClass={"btn text-dark btn-outline-info"}
          btnText={"View your profile"}
          total={TOTAL_REQUIRED}
          completed={totalCompleted}
          onClick={() => {
            navigateToStepOne();
          }}
        />
      ) : (
        <ProfileCard
          title={"Hi there, "}
          appData={appData}
          description={
            "The more info you add, the better the chance we can match you to the right job!"
          }
          iconName={"alert-circle"}
          iconClass={"text-danger"}
          btnClass={"btn btn-primary"}
          btnText={"Complete your profile"}
          total={TOTAL_REQUIRED}
          completed={totalCompleted}
          onClick={() => {
            navigateToFirstNonCompletedStep(appData);
          }}
        />
      )}
    </div>
  );
};

CandidateProfileSection.propTypes = {
  appData: object.isRequired,
};

export default CandidateProfileSection;
